import { useState } from "react";
import { useQueryParams } from "./useQueryParams";
import { useDebouncedValue } from "./useDebouncedValue";

/**
 * Общая логика полей поиска на страницах списков (Materials/Clients/Transactions):
 * состояние инициализируется из query-параметра "search", а сетевой запрос
 * должен использовать задебаунсенное значение, чтобы не слать запрос на
 * каждый введённый символ.
 */
export function useSearchQueryParam(delay = 400) {
  const queryParams = useQueryParams();
  const [searchTerm, setSearchTerm] = useState<string>(queryParams.getParam("search") || "");
  const debouncedSearchTerm = useDebouncedValue(searchTerm, delay);

  return { searchTerm, setSearchTerm, debouncedSearchTerm };
}
